import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from '../localization/localization.service';
import { CommonModule } from '@angular/common';
import { AppConfigService } from 'src/app/app-config.service';

@Component({
  selector: 'app-language-menu',
  templateUrl: './language-menu.component.html',
  styleUrls: ['./language-menu.component.scss'], 
  imports: [CommonModule, TranslateModule]
})
export class LanguageMenuComponent implements OnInit {

  supportedLanguages: string[];
  selectedLanguageCode: string;

  constructor(
    private localization: LocalizationService,
    private appConfigService: AppConfigService
  ) { }

  ngOnInit(): void {
    this.supportedLanguages = this.appConfigService.getConfig().supportedLanguages.map(x => x.code.capitalize());
    this.localization.currentLanguage$.subscribe(selected => {
      this.selectedLanguageCode = selected;
    })
  }

  onChangeLanguage(code: string) {
    this.selectedLanguageCode = code;
    this.localization.changeLanguage(code);
  }

  isCurrentlySelectedLanguage(language: string): boolean {
    return language.toLocaleLowerCase() == this.selectedLanguageCode.toLocaleLowerCase();
  }
}
